export * from './app-header.component';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/components/app-header/index.ts